import { useState } from 'react';
import Icon from '../common/Icon/Icon';
import { IconKeys } from '../common/Icon/IconKeys';
import S from './HeaderToolbarStyles';
import UserProfile from '../UserProfile/UserProfile';
import UserNotifications from '../Notifications/UserNotifications';
import Modal from '../common/Modal/Modal';
import NotificationSettings from '../Notifications/NotificationSettings';
import useGetRole from '../../API/hooks/useGetRole';

function HeaderToolbar({
  notes = false, bookmarks = false,
} : { notes?: boolean, bookmarks?: boolean }): JSX.Element {
  const [showNotificationSettings, toggleShowNotificationSettings] = useState(false);
  const { canAccessNotifications } = useGetRole();
  return (
    <S.Wrapper>
      {/* <div className="icon-container">
        <Icon iconKey={IconKeys.NOTES} />
        {notes && <span className="badge" />}
      </div>
      <div className="icon-container">
        <Icon iconKey={IconKeys.BOOKMARKS} />
        {bookmarks && <span className="badge" />}
      </div> */}
      {canAccessNotifications && (
        <>
          <UserNotifications onSettings={toggleShowNotificationSettings} />
          {showNotificationSettings && (
            <Modal
              title="Notification settings"
              state={showNotificationSettings}
              toggleState={toggleShowNotificationSettings}
              settings={{ maxWidth: '600px', minHeight: '550px', display: 'block' }}
            >
              <NotificationSettings toggleModal={toggleShowNotificationSettings} />
            </Modal>
          )}
        </>
      )}
      <UserProfile />
    </S.Wrapper>
  );
}

export default HeaderToolbar;
